module.exports = __webpack_public_path__ + "img/line.9befd0ba.svg";